import { Component, input } from '@angular/core';
import { LpConditionalVisibilityCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-conditional-visibility-canvas-component/lp-conditional-visibility-canvas-component.component';
import { LpDraggableCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-draggable-canvas-component/lp-draggable-canvas-component.component';
import { LpDropTargetCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-drop-target-canvas-component/lp-drop-target-canvas-component.component';
import { LpIfCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-if-canvas-component/lp-if-canvas-component.component';
import { LpImageCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-image-canvas-component/lp-image-canvas-component.component';
import { LpOnClickCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-on-click-canvas-component/lp-on-click-canvas-component.component';
import { LpOnTriggerCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-on-trigger-canvas-component/lp-on-trigger-canvas-component.component';
import { LpParallaxCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-parallax-canvas-component/lp-parallax-canvas-component.component';
import { LpSolidColorCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-solid-color-canvas-component/lp-solid-color-canvas-component.component';
import { LpTextCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-text-canvas-component/lp-text-canvas-component.component';
import { LpWebStyleSheetImageCanvasComponentComponent } from '@features/lp/lp-canvas/components/lp-web-style-sheet-image-canvas-component/lp-web-style-sheet-image-canvas-component.component';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { Wk8BookContentsCanvasComponentComponent } from '@features/wk8/lp-canvas/components/wk8-book-contents-canvas-component/wk8-book-contents-canvas-component.component';
import { LpCanvasElementComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-canvas-components',
  imports: [
    LpConditionalVisibilityCanvasComponentComponent,
    LpImageCanvasComponentComponent,
    LpOnClickCanvasComponentComponent,
    LpDropTargetCanvasComponentComponent,
    LpDraggableCanvasComponentComponent,
    LpParallaxCanvasComponentComponent,
    LpSolidColorCanvasComponentComponent,
    LpTextCanvasComponentComponent,
    Wk8BookContentsCanvasComponentComponent,
    LpIfCanvasComponentComponent,
    LpWebStyleSheetImageCanvasComponentComponent,
    LpOnTriggerCanvasComponentComponent,
  ],
  templateUrl: './lp-canvas-components.component.html',
  styleUrl: './lp-canvas-components.component.css',
})
export class LpCanvasComponentsComponent {
  components = input.required<LpCanvasElementComponent[]>();
  context = input.required<ILpCanvasElementContext>();

  private hasLogged = new Set();
  logUnsupported(comp: LpCanvasElementComponent) {
    if (this.hasLogged.has(comp.uid)) return;

    console.warn(`Canvas component type '${comp.dataType}' is not supported`, comp);
    this.hasLogged.add(comp.uid);
  }
}
